<template>
  <div class="check-installation">
    <img
      src="../../../assets/img/arnergy-5000X.png"
      alt="arnergy-5000X.png"
    /><br />

    <!-- Congratulations! Your solar system is now en route to your doorstep -->
    <h3>Welcome to your dashboard</h3>

    You have 0 installations, kindly click the button below to
    <br />
    <a
      href="https://arnergy.com/contacts/"
      target="_blank"
      class="btn btn-warning button"
    >
      Contact us
    </a>
  </div>
</template>

<script>
export default {
  name: "LandingOnboardingPage",
  components: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
.check-installation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 18px;
  text-align: center;
  padding: 2rem;
  font-size: 18px;
  // color: #939DAA;
  color: #333333;

  h3 {
    font-size: 24px;
    font-weight: 600;
  }

  img {
    height: 35%;
    width: 35%;
  }

  a {
    margin-top: 16px;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    border-radius: 6px !important;

    // .button {
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/landingOnboardingPage.vue